module.exports = __webpack_public_path__ + "media/images/games/memory_game/meemo/3-654d8d6b2acd916adc6d1ce028df5490.jpg";